export const supportedLngs = ["en", "tr"];

export const languageMeta = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "tr", name: "Türkçe", flag: "🇹🇷" },
];

export const fallbackLng = "en";
export const defaultNS = "common";

/** Bundled with @repo/ui (reusable-table, date fields, calendar). */
export const SHARED_UI_NS = "reusableTable";

/**
 * Load only the active language bundle (not fallbackLng in parallel).
 * Missing keys fall back to defaultValue / key string unless EN was already loaded.
 */
export const i18nLoadStrategy = "currentOnly";

/**
 * Isolated islands (tabs, catalog, report menu, widget board) still wait
 * for their own namespaces so the host page can paint chrome + table first.
 */
export const LATE_I18N_OPTIONS = Object.freeze({ useSuspense: true });

/**
 * Namespaces loaded at i18n init (shell + mutation toasts).
 * `lifecycle` is badge/strip chrome used across lists and details.
 * `integrationToasts` must be eager: integrations call `i18next.t` outside
 * React and cannot wait for on-demand namespace load (English defaultValue flash).
 * Feature page namespaces still load via useTranslation.
 */
export const coreNamespaces = [
  defaultNS,
  SHARED_UI_NS,
  "sidebar",
  "header",
  "breadcrumb",
  "forbidden",
  "notFound",
  "lifecycle",
  "integrationToasts",
  "notificationEvents",
];
